import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './settings.html';

@Component({
  controllerAs: 'settings',
  template
})

export default class Settings {
  static $inject = [
    '$scope',
    '$ngRedux',
    'authService',
    'toaster',
    '$rootScope',
    '$stateParams',
    '$window',
    'APP',
    '$state'
  ];

  constructor($scope, $ngRedux, $auth, toaster, $rootScope, $state, $stateParams, $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$auth = $auth;
    this.toaster = toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile
    };
  }
  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    let data = Object.assign({}, this.profile);
    if (!data.billingState) {
      data.billingState = {
        'code': null
      };
    }
    if (!data.shippingState) {
      data.shippingState = {
        'code': null
      };
    }
    if (!data.customer.state) {
      data.customer.state = {
        'code': null
      };
    }
    form.error = {};
    this.$auth.updateUserProfile(data, data.userId)
      .then(() => { this.toaster.pop('success', 'Your delivery mode has been updated successfully.');
      this.$rootScope.tempdeliveryMode=null;
    })
      .catch(err => form.error = err.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/settings/settings.js